/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin'] = {
  "react": [
    [
      "div",
      "background",
      [],
      {},
      [
        "div",
        "backgroundMedia",
        [],
        {}
      ]
    ],
    [
      "div",
      "borderNode",
      [],
      {}
    ],
    [
      "div",
      "inlineContentParent",
      [],
      {},
      [
        "div",
        "inlineContent",
        [],
        {}
      ]
    ]
  ],
  "params": {
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA"
  },
  "paramsDefaults": {
    "brw": "0",
    "brd": "color_11"
  },
  "css": {
    "%borderNode": "border:[brw] solid [brd];position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;",
    "%inlineContent": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "%inlineContentParent": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "%[data-shouldhideoverflowcontent=\"true\"]": "overflow:hidden;"
  }
}

    return skins;
});
